import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import Toast from '../components/Toast';

const CATEGORII = [
  { tip: 'magazii', nr: 1, label: 'Magazii', contor: 'magazii', dependinte: [] },
  { tip: 'furnizori', nr: 2, label: 'Furnizori', contor: 'furnizori', dependinte: [] },
  { tip: 'materiale', nr: 3, label: 'Materiale', contor: 'materiale', dependinte: [] },
  { tip: 'produse-finite', nr: 4, label: 'Produse finite (optional)', contor: 'produseFinite', dependinte: [] },
  { tip: 'retete', nr: 5, label: 'Retete (optional)', contor: 'retete', dependinte: ['materiale', 'produseFinite'] },
  { tip: 'stoc-initial', nr: 6, label: 'Stoc initial', contor: 'stocInitial', dependinte: ['magazii', 'materiale'], unicPeViata: true }
];

export default function ImportDate() {
  const [stare, setStare] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);
  const [importing, setImporting] = useState(null); // tip in curs de import
  const [erori, setErori] = useState(null); // { tip, lista }
  const inputRefs = useRef({});

  function incarcaStare() {
    setLoading(true);
    api.get('/api/import/stare').then(res => setStare(res.data)).finally(() => setLoading(false));
  }

  useEffect(incarcaStare, []);

  async function descarcaMacheta(tip) {
    try {
      const res = await api.get(`/api/import/macheta/${tip}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `macheta-${tip}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setToast({ message: 'Eroare la descarcarea machetei', type: 'error' });
    }
  }

  function declanseazaImport(tip) {
    setErori(null);
    inputRefs.current[tip]?.click();
  }

  async function fisierAles(tip, e) {
    const fisier = e.target.files[0];
    e.target.value = ''; // permite re-selectarea aceluiasi fisier ulterior
    if (!fisier) return;
    setImporting(tip);
    setErori(null);
    try {
      const formData = new FormData();
      formData.append('fisier', fisier);
      const res = await api.post(`/api/import/${tip}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setToast({ message: `Import reusit - ${res.data.randuriImportate} randuri`, type: 'ok' });
      incarcaStare();
    } catch (err) {
      if (err.response?.data?.erori) {
        setErori({ tip, lista: err.response.data.erori });
      } else {
        setToast({ message: err.response?.data?.error || 'Eroare la import', type: 'error' });
      }
    } finally {
      setImporting(null);
    }
  }

  async function inchideImportul() {
    if (!window.confirm('Sigur inchizi importul? Odata inchis, nu mai poate fi redeschis, si niciuna din categoriile de mai sus nu va mai fi disponibila.')) return;
    try {
      await api.post('/api/import/inchide');
      setToast({ message: 'Importul a fost inchis', type: 'ok' });
      incarcaStare();
    } catch (err) {
      setToast({ message: 'Eroare la inchiderea importului', type: 'error' });
    }
  }

  function dependinteIndeplinite(cat) {
    if (!stare) return false;
    return cat.dependinte.every(dep => {
      const contor = dep === 'magazii' ? stare.magazii : dep === 'materiale' ? stare.materiale
        : dep === 'produseFinite' ? stare.produseFinite : 0;
      return contor > 0;
    });
  }

  if (loading) return <p>Se incarca...</p>;

  if (!stare?.importDeschis) {
    return (
      <div>
        <h1>Import initial de date</h1>
        <div className="card">
          <p>Importul initial este <strong>inchis</strong> pentru aceasta firma - fie a fost deja finalizat, fie firma nu a fost eligibila (doar firmele nou create au acces la aceasta functie).</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1>Import initial de date</h1>
      <div className="card" style={{ background: '#fff7e6', border: '1px solid #f0d080' }}>
        <p style={{ margin: 0 }}>
          <strong>Importurile trebuie facute in ordine, de la 1 la 6</strong> - un pas ulterior poate esua daca cel de
          dinainte nu a fost facut inca (ex: Stocul initial are nevoie ca Magaziile si Materialele sa existe deja).
          Randurile care inca nu-si au dependentele indeplinite sunt dezactivate mai jos.
        </p>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr><th>#</th><th>Categorie</th><th>Deja incarcate</th><th></th><th></th></tr>
          </thead>
          <tbody>
            {CATEGORII.map(cat => {
              const contorValoare = stare[cat.contor] ?? 0;
              const disponibil = dependinteIndeplinite(cat);
              const dejaImportatUnic = cat.unicPeViata && contorValoare > 0;
              return (
                <tr key={cat.tip} style={!disponibil ? { opacity: 0.45 } : undefined}>
                  <td>{cat.nr}</td>
                  <td>{cat.label}</td>
                  <td>{contorValoare}</td>
                  <td>
                    <button type="button" className="btn secondary" onClick={() => descarcaMacheta(cat.tip)}>Macheta</button>
                  </td>
                  <td>
                    <input type="file" accept=".xlsx" style={{ display: 'none' }}
                      ref={el => (inputRefs.current[cat.tip] = el)}
                      onChange={(e) => fisierAles(cat.tip, e)} />
                    <button type="button" className="btn" disabled={!disponibil || dejaImportatUnic || importing === cat.tip}
                      onClick={() => declanseazaImport(cat.tip)}>
                      {dejaImportatUnic ? 'Deja importat' : importing === cat.tip ? 'Se importa...' : 'Import macheta'}
                    </button>
                    {dejaImportatUnic && (
                      <p style={{ fontSize: 12, color: '#888', margin: '4px 0 0' }}>
                        Se poate incarca o singura data - pentru completari ulterioare, foloseste Miscari stoc.
                      </p>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {erori && (
          <div style={{ marginTop: 12, background: '#fdecea', border: '1px solid #e0a8a0', borderRadius: 6, padding: 12 }}>
            <p style={{ marginTop: 0, fontWeight: 600 }}>
              Fisierul pentru „{CATEGORII.find(c => c.tip === erori.tip)?.label}" nu a fost importat - {erori.lista.length} eroare(erori):
            </p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {erori.lista.map((e, i) => <li key={i}>{e}</li>)}
            </ul>
          </div>
        )}
      </div>

      <div className="card">
        <p style={{ marginTop: 0 }}>
          Cand ai terminat de incarcat tot ce ai nevoie, inchide definitiv importul - firma trece in regim normal de lucru.
        </p>
        <button type="button" className="btn danger" onClick={inchideImportul}>Inchide importul</button>
      </div>

      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
}
